import { useEffect, useRef, useState } from 'react';
import { Image, Box } from '@chakra-ui/react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ReactPlayer from 'react-player';

const responsive = {
  mobile: {
    breakpoint: { max: 4000, min: 0 },
    items: 1,
  },
};
export default function ProductPhotosMobile({ productMedia, productTitle, handleZoom }) {
  let carousel = useRef(null);

  useEffect(() => {
    if (carousel.current) carousel.goToSlide(0);
  }, [productTitle]);

  if (!productMedia || productMedia.length === 0) return null;

  return (
    <Box w={'100%'} display={'inline-block'} px={'-20px'} className="single-product-carousel">
      <Carousel responsive={responsive} showDots ref={(el) => (carousel = el)}>
        {productMedia?.map(({ url, type }, index) =>
          type === 'image' ? (
            <Image
              width={'100%'}
              height={{ base: '250px', lg: 'auto' }}
              objectFit="contain"
              alt={productTitle}
              src={url}
              key={`productMedia-${index}`}
              onClick={() => {
                handleZoom(index);
              }}
              id={index}
            />
          ) : (
            <Box
              paddingBottom={'99% !important'}
              style={{ position: 'relative', width: '100%', height: 0 }}
              position={'relative'}
              className="video-product"
            >
              <ReactPlayer
                loop={true}
                playing={true}
                controls={false}
                volume={0}
                width="100%"
                height="100%"
                style={{ position: 'absolute', top: 0, left: 0 }}
                playsinline={true}
                url={url}
                key={url}
              />
            </Box>
          )
        )}
      </Carousel>
    </Box>
  );
}
